<template>
  <div class="content_div">
    <el-card>
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
        <el-form-item label="分类名称">
          <el-input clearable class="input_class" v-model="query.categoryName" auto-complete="off" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
        <el-button type="success" @click="btnInsert()">新增</el-button>
      </el-form>

      <el-table
        v-loading="loading"
        :data="dataList"
        row-key="id"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="categoryName" label="分类名称" />
        <el-table-column prop="sort" label="排序" width="100" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" />
        <el-table-column align="center" label="操作" width="210">
          <template slot-scope="scope">
            <el-button size="small" type="info" @click="btnUpdate(scope.row)">修改</el-button>
            <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :close-on-click-modal="false" title="分类管理" :visible="isShowDialogFlag" @close="close" width="50%">
      <el-form label-width="120px" :model="data" ref="data" :rules="rules">
        <el-form-item label="父级分类" prop="parentId">
          <el-select v-model="data.parentId" placeholder="请选择父级分类（不选则为顶级分类）" clearable style="width: 100%;">
            <el-option label="顶级分类" :value="0"></el-option>
            <el-option v-for="item in categoryTree" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="分类名称" prop="categoryName">
          <el-input v-model="data.categoryName" maxlength="50" auto-complete="off" placeholder="请输入分类名称"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="data.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="data.sort" :min="0" controls-position="right" style="width: 100%;"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="data.remark" maxlength="200" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click='close'>取消</el-button>
        <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCategoryPage, insertCategory, updateCategory, deleteCategory, listEnabledCategories } from '@/api/ordering/category'

export default {
  name: 'GoodsCategory',
  async created() {
    await this.load()
  },
  data() {
    return {
      loading: true,
      dataList: [],
      categoryTree: [],
      query: {
        currentPage: 1,
        pageSize: 100,
        categoryName: undefined
      },
      isShowDialogFlag: false,
      data: {
        id: null,
        parentId: 0,
        categoryName: null,
        status: 1,
        sort: 1,
        remark: null
      },
      rules: {
        categoryName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async load() {
      this.loading = true
      let res = await getCategoryPage(this.query)
      this.dataList = res.records || []
      this.loading = false
      // 加载分类树用于选择父级分类
      await this.loadCategoryTree()
    },
    async loadCategoryTree() {
      let res = await listEnabledCategories()
      this.categoryTree = res || []
    },
    btnInsert() {
      this.data = {
        id: null,
        parentId: 0,
        categoryName: null,
        status: 1,
        sort: 1,
        remark: null
      }
      this.isShowDialogFlag = true
    },
    btnUpdate(row) {
      this.data = JSON.parse(JSON.stringify(row))
      this.isShowDialogFlag = true
    },
    async close() {
      this.isShowDialogFlag = false
      if (this.$refs.data) {
        this.$refs.data.clearValidate()
      }
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let result = !this.data.id ? await insertCategory(this.data) : await updateCategory(this.data)
          this.$message.success('操作成功')
          await this.close()
          await this.load()
        }
      })
    },
    async btnDelete(id) {
      this.$confirm('确定要删除该分类吗？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteCategory(id)
        this.$message.success('操作成功')
        await this.load()
      })
    }
  }
}
</script>

<style scoped>
.content_div {
  padding: 20px;
}

/* 弹窗内容间距优化 */
::v-deep .el-dialog__body {
  padding: 20px 30px;
}

/* 弹窗头部间距 */
::v-deep .el-dialog__header {
  padding: 20px 30px 15px;
  margin-right: 0;
}

/* 弹窗底部间距 */
::v-deep .el-dialog__footer {
  padding: 15px 30px 20px;
}

/* 表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}
</style>
